import axiosIns from '@/libs/axios'
import reviewsStore from '@/views/driver-user-shared/driver-user-reviews/store'

export default {
  namespaced: true,
  modules: {
    reviews: reviewsStore,
  },
  state: {
    tripDetails: null,
    tripBillDetails: null,
    tripInfoLoading: {
      details: false,
      dispatch: false,
      cancellation: undefined,
      bill: false,
      path: false,
    },
    tripId: null,
    tripActions: [],
    tripPath: [],
    driverLocation: null,
  },
  getters: {
    getTripDetails(state) {
      return state.tripDetails
    },
    getTripBillDetails(state) {
      return state.tripBillDetails
    },
    getTripInfoLoading(state) {
      return state.tripInfoLoading
    },
    getTripActions(state) {
      return state.tripActions
    },
    getTripPath(state) {
      return state.tripPath
    },
    getDriverLocation(state) {
      return state.driverLocation
    },
  },
  mutations: {
    SET_TRIP_DETAILS_ID(state, id) {
      state.tripId = id
    },
    SET_TRIP_BILL_DETAILS(state, data) {
      state.tripBillDetails = data
    },
    SET_TRIP_INFO_LOADING(state, loadingInformation) {
      state.tripInfoLoading = loadingInformation
    },
    SET_TRIP_DETAILS(state, details) {
      state.tripDetails = details
    },
    SET_TRIP_ACTIONS(state, actions) {
      state.tripActions = actions
    },
    RESET_TRIP_INFORMATION(state) {
      state.tripBillDetails = null
      state.tripId = null
      state.driverLocation = null
      state.tripDetails = []
      state.tripActions = []
      state.tripPath = []
    },
    SET_TRIP_PATH(state, path) {
      state.tripPath = path
    },
    SET_DRIVER_LOCATION(state, loc) {
      state.driverLocation = loc
    },
  },
  actions: {
    calculateTripStatsDates() {
      const midNight = new Date()
      midNight.setHours(0, 0, 0)
      // yesteday
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      yesterday.setHours(0, 0, 0)
      const today = new Date()
      today.setHours(0, 0, 0)
      // last week
      const now = new Date()
      const lastweek = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
      lastweek.setHours(0, 0, 0)
      const lastweekMinusOneDay = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000)
      lastweekMinusOneDay.setHours(0, 0, 0)

      return {
        todayFrom: midNight,
        todayTo: new Date(),
        yesterdayFrom: yesterday,
        yesterdayTo: today,
        yesterdayTillNowFrom: yesterday,
        yesterdayTillNowTo: new Date((new Date().getTime() - 24 * 60 * 60 * 1000) - 1),
        lastweekFrom: lastweek,
        lastweekTo: lastweekMinusOneDay,
        lastweekTillNowFrom: lastweek,
        lastweekTillNowTo: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000),
      }
    },
    async fetchNoDriverFoundAndCanceledStats({ dispatch }, { serviceType }) {
      const params = await dispatch('calculateTripStatsDates')
      const res = (await axiosIns.get('trips/stats/state', {
        params: {
          from: params.todayFrom,
          to: params.todayTo,
          service_type: serviceType,
        },
      })).data.data
      return res
    },
    async fetchDriverAggsByCompletedTrips({ dispatch }, { serviceType }) {
      const params = await dispatch('calculateTripStatsDates')
      const res = (await axiosIns.get('trips/stats/driver', {
        params: {
          ...params,
          service_type: serviceType,
        },
      })).data.data
      return res
    },
    async getOnlineDrivers({ dispatch }, { serviceType }) {
      const params = await dispatch('calculateTripStatsDates')
      const res = (await axiosIns.get('trips/stats/driver/online', {
        params: {
          from: params.todayFrom,
          to: params.todayTo,
          service_type: serviceType,
        },
      })).data.data
      return res
    },
    async fetchTripsStats({ dispatch }, { serviceType }) {
      const params = await dispatch('calculateTripStatsDates')
      const res = (await axiosIns.get('trips/stats', {
        params: {
          ...params,
          service_type: serviceType,
        },
      })).data.data
      return res
    },
    async fetchTripsStatsByZone({ dispatch }) {
      const params = await dispatch('calculateTripStatsDates')
      const res = (await axiosIns.get('trips/stats/zone', {
        params,
      })).data.data

      return res
    },
    searchPlaces({ state }, { text }) {
      return axiosIns.get(`trips/${state.tripId}/google/search/${text}`)
    },
    getPlaceLatLong(_, { placeId }) {
      return axiosIns.get(`trips/geocode/${placeId}`)
    },
    async fetchTripPath({ commit, state, dispatch }) {
      try {
        // truthy loading set in the fetch trip details action
        const usedTripId = state.tripId
        commit('SET_TRIP_PATH', [])
        const paths = (await axiosIns.get(`/trips/${usedTripId}/path`)).data.data
        commit('SET_TRIP_PATH', paths)
        if (state.tripDetails.state !== 'COMPLETED' && Object.keys(state.tripDetails.driver_details).length) {
          const locationResult = await dispatch('drivers/fetchDriverLocation', state.tripDetails.driver_details.external_id, { root: true })
          commit('SET_DRIVER_LOCATION', locationResult.data.data.location)
        }
      } catch (error) {
        console.log(error)
      } finally {
        commit('SET_TRIP_INFO_LOADING', {
          ...state.tripInfoLoading,
          path: false,
        })
      }
    },
    async fetchTripsList(_, params) {
      return axiosIns.get('/trips', {
        params,
        timeout: 5000,
      })
    },
    async fetchCancelationReasons(_, { tripId }) {
      const result = await axiosIns.get(`trips/${tripId}/cancellation-reasons`)
      return result
    },

    async assignCancelationReasons(_, data) {
      const result = await axiosIns.post('trips/cancellation-reasons', data)
      return result
    },
    async fetchTripDetails({ commit, state, dispatch }) {
      try {
        commit('SET_TRIP_INFO_LOADING', {
          ...state.tripInfoLoading,
          details: true,
          path: true,
        })
        const res = await axiosIns.get(`/trips/${state.tripId}`)
        // variable for data manipulation before setting it to state
        const tripDetails = res.data.data
        commit('SET_TRIP_DETAILS', tripDetails)
        if (tripDetails.state === 'COMPLETED') {
          commit('SET_TRIP_INFO_LOADING', {
            ...state.tripInfoLoading,
            bill: true,
          })
        } else if (tripDetails.state === 'CANCELED') {
          commit('SET_TRIP_INFO_LOADING', {
            ...state.tripInfoLoading,
            cancellation: true,
          })
        }

        commit('SET_TRIP_INFO_LOADING', {
          ...state.tripInfoLoading,
          details: false,
          dispatch: true,
        })

        await dispatch('fetchTripTriggers', tripDetails.state)

        if (Object.keys(tripDetails.driver_details).length) {
          const driverReview = await dispatch('reviews/fetchReviews', {
            reviewableType: 'drivers',
            reviewableId: tripDetails?.driver_details.id,
          })
          const driverAverage = driverReview.data.data.statistics?.average
          tripDetails.driver_details.rating = driverAverage
        }
        const userReview = await dispatch('reviews/fetchReviews', {
          reviewableType: 'users',
          reviewableId: tripDetails?.user_details.id,
        })
        const userAverage = userReview.data.data.statistics?.average
        tripDetails.user_details.rating = userAverage
        commit('SET_TRIP_DETAILS', tripDetails)

        const result = await axiosIns.get(`/dispatch/dispatchers/trip-details/${tripDetails?.id}`)
        tripDetails.dispatches = result.data.data.dispatches
        commit('SET_TRIP_DETAILS', tripDetails)
        commit('SET_TRIP_INFO_LOADING', {
          ...state.tripInfoLoading,
          dispatch: false,
        })

        if (tripDetails.state === 'COMPLETED') {
          const tripBill = (await axiosIns.get(`bills/snapshots/externals/${tripDetails?.id}`)).data.data
          let payments
          if (tripBill?.id) {
            payments = (await axiosIns.get(`payments/transactions/bills/${tripBill?.id}`)).data.data.data
          }
          if (payments) {
            commit('SET_TRIP_BILL_DETAILS', {
              ...tripBill,
              payment: {
                ...payments,
              },
            })
          } else {
            commit('SET_TRIP_BILL_DETAILS', {
              ...tripBill,
            })
          }
          commit('SET_TRIP_INFO_LOADING', {
            ...state.tripInfoLoading,
            bill: false,
          })
        }

        const { pickup } = tripDetails.metadata.location
        let destination = null
        if (tripDetails.state === 'COMPLETED') {
          destination = tripDetails.metadata.actual_drop_off
        } else {
          destination = tripDetails.metadata.location.dropoff
        }
        if (pickup && destination) {
          const directionsResponse = await axiosIns.get('/google/directions', {
            params: {
              origin: `${pickup.latitude},${pickup.longitude}`,
              destination: `${destination.latitude},${destination.longitude}`,
            },
          })
          const directionsData = directionsResponse.data.data
          if (directionsData.routes) {
            tripDetails.googlePath = directionsData.routes[0].legs[0].steps
          } else {
            tripDetails.orsPath = directionsData.results.features && directionsData.results.features[0].geometry.coordinates
          }
        }
        commit('SET_TRIP_DETAILS', tripDetails)

        await dispatch('fetchTripPath')

        if (tripDetails.state === 'CANCELED') {
          tripDetails.cancellationDetails = {}
          const canceledState = tripDetails.states.find(st => st.state === 'CANCELED')
          const canceledIndex = tripDetails.states.findIndex(st => st.state === 'CANCELED')
          const arrivedIndex = tripDetails.states.findIndex(st => st.state === 'ARRIVED')

          if (arrivedIndex === -1 || canceledIndex < arrivedIndex) {
            tripDetails.cancellationDetails.cancellationState = 'Before arrived'
          } else if (canceledIndex > arrivedIndex) {
            tripDetails.cancellationDetails.cancellationState = 'After arrived'
          }
          const isCanceledByUser = canceledState.metadata.action_by === 'user'
          const isCanceledByDriver = canceledState.metadata.action_by === 'driver'

          Object.keys(canceledState).forEach(key => {
            tripDetails.cancellationDetails[key] = canceledState[key]
          })

          if (isCanceledByDriver) {
            // To be changed to determine either canceled by driver before arrived or after arrived,
            // this case should be after arrived but it`s set for both for now
            tripDetails.cancellationDetails.payingStatus = 'Cancellation fees on user'
          }

          if (isCanceledByUser) {
            // This dispatch sets the current user wallet id in the users store
            await dispatch('users/fetchUserWallet', tripDetails.user_details.id, { root: true })

            const { pending_transactions } = (await dispatch('users/fetchUserPendingTransactions',
              { page: 1, size: 1000, external_reference_id: tripDetails.id },
              { root: true }))
              .data.data
            const hasDebitValue = pending_transactions.find(t => +t.debit_amount !== 0)

            if (hasDebitValue) {
              tripDetails.cancellationDetails.payingStatus = 'Cancellation fees on user'
            } else {
              tripDetails.cancellationDetails.payingStatus = 'Free cancellation'
            }
          }
          commit('SET_TRIP_DETAILS', tripDetails)

          const cancellationReasons = (await axiosIns.get(`/trips/configurations/${state.tripId}`)).data.data.cancellation_reasons
          const reasonFound = cancellationReasons.find(reason => +reason.id === +tripDetails.cancellation_reason_id)
          tripDetails.cancellationDetails.cancellationReasonLabel = reasonFound?.label
          commit('SET_TRIP_DETAILS', tripDetails)
          commit('SET_TRIP_INFO_LOADING', {
            ...state.tripInfoLoading,
            cancellation: false,
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    releaseTrip(_, { userType, userExternalId }) {
      return axiosIns.delete(`trips/inflight/${userType}/${userExternalId}`)
    },
    async fetchTripTriggers({ state, commit }, tripState) {
      const canGetTripTriggers = ['ARRIVED', 'LOOKING_FOR_DRIVER', 'CREATED', 'ACCEPTED', 'IN_PROGRESS', 'CANCELED'].includes(tripState)
      if (canGetTripTriggers) {
        const res = (await axiosIns.get(`/trips/triggers/${state.tripId}`)).data.data
        commit('SET_TRIP_ACTIONS', res.actions)
      }
    },
    async applyActionOnTrip({ state, dispatch }, {
      action, actionDescription, cancellation_reason_id, actualDropoff, data,
    }) {
      const { code, payment_method_id: paymentMethodId } = state.tripDetails
      const reqBody = {
        code,
        action,
        cancellation_reason_id,
      }
      if (action === 'arrive') {
        reqBody.action_by = 'admin'
      }
      if (action === 'start') {
        reqBody.action_by = 'system'
      }
      if (action === 'end') {
        reqBody.action_by = 'driver'
        if (actualDropoff) {
          reqBody.actualDropoff = actualDropoff
        }
        if (paymentMethodId) {
          reqBody.payment_method_id = paymentMethodId
        }
        if (data) {
          reqBody.data = {
            distance: data.distance,
            endTime: data.endTime,
          }
        }
      }
      if (action === 'cancel') {
        if (actionDescription === 'feeOnUser') {
          reqBody.action_by = 'admin_fee_on_user'
        } else if (actionDescription === 'feeOnDriverWithoutReAssign') {
          reqBody.action_by = 'admin_fee_on_driver'
        } else if (actionDescription === 'noFee') {
          reqBody.action_by = 'admin_with_out_fee'
        }
      }
      if (action === 'cancel' && actionDescription === 'feeOnDriverWithReAssign') {
        await axiosIns.post(`/trips/dispatch-transitions/${state.tripId}`, {
          bypassFines: false,
        })
      } else if (action === 'cancel' && actionDescription === 'noFeeOnDriverWithReAssign') {
        await axiosIns.post(`/trips/dispatch-transitions/${state.tripId}`, {
          bypassFines: true,
        })
      } else {
        await axiosIns.post(`/trips/transitions/${state.tripId}`, reqBody)
      }
      dispatch('fetchTripDetails')
    },
  },
}
